import React, { Component } from 'react';
import * as emailjs from "emailjs-com";
import ReactGA from "react-ga4";


class ContactForm extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            values: {
                name: '',
                email: '',
                message: ''
            },
            successMessage: "Správa bola úspešne odoslaná.",
            warningMessage: 'Prosím, vyplnte formulár!',
            errorMessage: 'Niečo sa pokazilo. Skúste prosím znovu!',
            alertClass: '',
            responseMessage: '',
            alertTimeout: '',
            delay: 5000
        };
    };

    submitForm = async e => {
        try {
            e.preventDefault();

            if ( document.querySelector( '#alert' ) ) {
                document.querySelector( '#alert' ).remove();
            }

            this.setState( { isSubmitting: true } );

            const templateParams = {
                name: this.state.values.name,
                email: this.state.values.email,
                message: this.state.values.message,
            };
            await emailjs.send(
                'service_adwx3bf',
                'template_i9zwa4l',
                templateParams,
                'user_fLnME9HoTLwQLsu07Q8ut'
            );

            this.setState( { responseMessage: this.state.successMessage } );
            this.callAlert( this.state.responseMessage, 'success' )
        } catch (e) {
            console.log(e);
            this.setState( { responseMessage: this.state.errorMessage } );
            this.callAlert( this.state.errorMessage, 'error' )

            ReactGA.exception({
                description: 'Contact submit error ocurred',
                fatal: true
            });
        }

        ReactGA.event({
            category: 'Contact',
            action: 'Form submit'
        });
    };

    removeAlert = () => {
        clearTimeout( this.state.alertTimeout );
        this.setState( {
            alertTimeout: setTimeout( function() {
                    var element = document.querySelector( '#alert' );
                    element.classList.remove( 'fadeIn' );
                    element.classList.add( 'fadeOut' );
                    setTimeout( function() {
                        element.remove()
                    }, 900 )
                }, this.state.delay
            )
        } );
    };

    callAlert = ( message, type ) => {
        if ( ! document.querySelector( '#alert' ) ) {
            if ( type === 'success' ) {
                this.setState( { alertClass: 'success' } )
            }

            if ( type === 'error' ) {
                this.setState( { alertClass: 'danger' } )
            }

            if ( type === 'warning' ) {
                this.setState( { alertClass: 'warning' } )
            }

            var alert = '<div id="alert" class="animated fadeIn alert alert--shadow alert-' + this.state.alertClass + '">' + message + '</div>';

            var element = document.querySelector( '#cf-1' );

            element.insertAdjacentHTML( 'beforeend', alert );

            this.removeAlert();
        }
    };

    handleInputChange = e =>
        this.setState( {
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
    } );

    render() {
        return (
            <form onSubmit={ this.submitForm } method="post" action="form.php" id="cf-1" className="contact-form" data-aos="fade-up">
                <div className="form-group form-group-sm" data-aos="fade-up">
                    <label htmlFor="cf-1-name" className="form-label-lg before">Meno</label>
                    <input 
                        name="name" 
                        type="text" 
                        id="cf-1-name" 
                        placeholder="Vaše meno"
                        required="required" 
                        className="form-control form-control-lg"
                        value={ this.state.values.name }
                        onChange={ this.handleInputChange }
                    />
                </div>

                <div className="form-group form-group-sm" data-aos="fade-up">
                    <label htmlFor="cf-1-email" className="form-label-lg before">Email</label>
                    <input 
                        name="email" 
                        type="email" 
                        id="cf-1-email" 
                        placeholder="Váš email"
                        required="required" 
                        className="form-control form-control-lg"
                        value={ this.state.values.email }
                        onChange={ this.handleInputChange }
                    />
                </div>

                <div className="form-group form-group-sm" data-aos="fade-up">
                    <label htmlFor="cf-1-message" className="form-label-lg before">Správa</label>
                    <textarea 
                        name="message" 
                        id="cf-1-message"
                        placeholder="Napíšte vašu správu"
                        required="required" 
                        className="form-control form-control-lg"
                        value={ this.state.values.message }
                        onChange={ this.handleInputChange }
                    ></textarea>
                </div>

                <div className="form-group form-group-sm mb-0" data-aos="fade-up">
                    <button type="submit" className="btn btn-primary">Poslať správu</button>
                </div>
            </form>
        );
    };
};

export default ContactForm;
